import { UserJson } from '../../types/models';
import { CamionNetBaseApiClient } from '../base-client';

/**
 * Authentication API Types
 */
export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  jwt: { access_token: string };
  user: UserJson;
}

export interface LogoutResponse {
  authenticated: boolean;
}

export interface GetProfileResponse {
  user: UserJson;
}
/**
 * Authentication API Endpoints
 */
export class AuthApi extends CamionNetBaseApiClient {
  /**
   * Login with username and password
   */
  async login(data: LoginRequest): Promise<LoginResponse> {
    return this.request<LoginResponse>('/auth/login/', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  /**
   * Logout the current user
   */
  async logout(): Promise<LogoutResponse> {
    return this.request<LogoutResponse>('/auth/logout');
  }

  /**
   * Get the current user's profile
   */
  async getProfile(): Promise<GetProfileResponse> {
    return this.request<GetProfileResponse>('/auth/profile');
  }
}
